module.exports = __webpack_public_path__ + "static/deneir-symbol-SCAG-d8dc8d4d52525cb46bc4304b490a8f3c.png";